import { Link } from 'react-router-dom';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import type { ChatModerationHold } from '@wlb/shared/types/context';
import { ReviewShieldIcon } from '../../components/ui/icons';
import './moderation.css';

interface ModerationHoldNoticeProps {
  hold: ChatModerationHold;
  onDismiss: () => void;
}

/**
 * Inline notice for a chat send or edit the API refused with HTTP 422.
 *
 * This is deliberately not a toast: the failure belongs to the composer the
 * user is looking at, and it needs to stay on screen long enough to read the
 * guidelines link rather than fading after a few seconds.
 */
export function ModerationHoldNotice({ hold, onDismiss }: ModerationHoldNoticeProps) {
  const { t } = useTranslation();
  const isEdit = hold.kind === 'edit';

  return (
    <div className="moderation-hold" role="alert">
      <ReviewShieldIcon size={18} className="moderation-hold__icon" aria-hidden />
      <div className="moderation-hold__body">
        <strong className="moderation-hold__title">
          {isEdit
            ? t('moderation.chat.editHeldTitle')
            : t('moderation.chat.sendHeldTitle')}
        </strong>
        <p className="moderation-hold__text">
          {isEdit
            ? t('moderation.chat.editHeldMessage')
            : t('moderation.chat.sendHeldMessage')}
        </p>
        <Link className="moderation-hold__link" to="/support/community-guidelines">
          {t('moderation.guidelinesLink')}
        </Link>
      </div>
      <button
        type="button"
        className="moderation-hold__dismiss"
        onClick={onDismiss}
        aria-label={t('moderation.accessibility.dismissHold')}
      >
        ×
      </button>
    </div>
  );
}
